import { useEffect } from 'react';
import { StyledSidePanelManageCookiesContainer } from './ManageCookies.styles';
import enviro from 'enviro';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const SidePanelManageCookies = ({
  isMobile
}) => {
  const isCookieBannerOnPage = document.getElementsByClassName('cookie-banner-top-static').length > 0;
  const isQA = enviro.isQa();
  if (!isCookieBannerOnPage && isQA) {
    console.warn('Cookie banner script is not loaded on this page, the ManageCookies component will not render');
  }
  useEffect(() => {
    try {
      const hiddenFooterCookieSettings = document.querySelector('.hs-footer-cookie-settings[hidden]');
      if (hiddenFooterCookieSettings && window._hsg.compliance) {
        window._hsg.compliance.addSettingsLink();
      }
    } catch (error) {
      console.log('Error loading Manage Cookies link');
    }
  }, [isCookieBannerOnPage]);
  return /*#__PURE__*/_jsx(StyledSidePanelManageCookiesContainer, {
    isMobile: isMobile,
    children: /*#__PURE__*/_jsx("div", {
      className: "hs-footer-cookie-settings",
      hidden: true,
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(Link, {
          href: "#",
          underline: true
        })
      })
    })
  });
};